var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancedDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 576,
    viewBox: "0 0 1440 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4604_24643)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4604_24643",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V576H0V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V576H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_4604_24643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827.217 409.881C1122.54 361.047 1104.26 405.812 1270.32 472.051C1333.44 497.229 1228.87 540.066 1134.16 602.391C1094.51 628.486 615.701 675.363 465.046 668.639C-10.0515 647.432 287.961 605.075 282.906 582.796C277.852 560.517 531.896 458.714 827.217 409.881Z",
    fill: "#11AB7D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1228.36 4.92048C1240.42 6.76139 1249 17.3552 1249 29.553V221.084L1384.46 85.6266C1393.08 77.0005 1406.64 75.5767 1416.47 82.8067C1433.7 95.4857 1450.2 109.621 1465.79 125.212C1481.38 140.803 1495.51 157.299 1508.19 174.53C1515.42 184.356 1514 197.916 1505.37 206.542L1369.91 342H1561.45C1573.64 342 1584.24 350.58 1586.08 362.638C1589.33 383.93 1590.97 405.419 1591 426.911C1591 427.304 1591 427.696 1591 428.089C1590.97 449.581 1589.33 471.071 1586.08 492.363C1584.24 504.421 1573.64 513 1561.45 513H1369.91L1505.37 648.459C1514 657.085 1515.42 670.645 1508.19 680.471C1495.51 697.702 1481.38 714.197 1465.79 729.788C1450.2 745.38 1433.7 759.515 1416.47 772.194C1406.64 779.424 1393.08 778 1384.46 769.374L1249 633.917V825.447C1249 837.645 1240.42 848.239 1228.36 850.079C1207.13 853.321 1185.7 854.961 1164.27 854.999C1163.76 855 1163.24 855 1162.73 854.999C1141.3 854.961 1119.87 853.321 1098.64 850.08C1086.58 848.239 1078 837.645 1078 825.447V633.915L942.542 769.373C933.916 778 920.356 779.423 910.53 772.193C893.299 759.514 876.803 745.379 861.212 729.788C845.621 714.197 831.486 697.701 818.807 680.47C811.577 670.644 813 657.084 821.627 648.458L957.084 513H765.553C753.355 513 742.761 504.421 740.92 492.363C734.36 449.39 734.36 405.61 740.92 362.638C742.761 350.58 753.355 342 765.553 342H957.084L821.626 206.543C813 197.917 811.576 184.357 818.806 174.531C831.485 157.299 845.62 140.803 861.212 125.212C876.803 109.621 893.298 95.4862 910.529 82.8073C920.355 75.5773 933.915 77.001 942.541 85.6272L1078 221.087V29.5528C1078 17.355 1086.58 6.76113 1098.64 4.92026C1141.61 -1.64016 1185.39 -1.64009 1228.36 4.92048Z",
    fill: "url(#paint0_linear_4604_24643)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 575H0V577H1440V575Z",
    fill: "black",
    fillOpacity: 0.15,
    mask: "url(#path-1-inside-1_4604_24643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4604_24643",
    x: -704.758,
    y: -510.752,
    width: 2894.3,
    height: 2080.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 450,
    result: "effect1_foregroundBlur_4604_24643"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4604_24643",
    x1: 1460.06,
    y1: 113.344,
    x2: 896.442,
    y2: 676.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11AB7D",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11AB7D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4604_24643"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V576H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedDesktop);
export default __webpack_public_path__ + "static/media/advanced-desktop.bdc779efb0313c9c163c3781cdaf7c99.svg";
export { ForwardRef as ReactComponent };